// extracted by mini-css-extract-plugin
export default {"p":"j6P4Y1TvzDDAYtzoZGsj"};